import { render, staticRenderFns } from "./ContactSmall.vue?vue&type=template&id=05958e94&scoped=true&"
import script from "./ContactSmall.vue?vue&type=script&lang=js&"
export * from "./ContactSmall.vue?vue&type=script&lang=js&"
import style0 from "./ContactSmall.vue?vue&type=style&index=0&id=05958e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05958e94",
  null
  
)

export default component.exports